module.exports = __webpack_public_path__ + "img/lowerabs-mesomorph-female.d8c812c2.svg";